import { useQuery } from "@tanstack/react-query";
import { useAuthStore } from "@/stores/auth.store";
import { teamSubscriptionService } from "@/services/team-subscription.service";
import { Icon } from "@/components/ui/icon"
import {
  getSubscriptionReminderMessage,
  shouldShowSubscriptionReminder,
} from "@/utils/team-subscription.utils";

type Props = {
  teamId: string;
};

export function GameTeamSubscriptionReminder({ teamId }: Props) {
  const { user } = useAuthStore();

  const { data: subscription } = useQuery({
    queryKey: ["teamMySubscription", teamId, user?.id],
    queryFn: () => teamSubscriptionService.getMySubscription(teamId),
    enabled: !!user && !!teamId,
    staleTime: 1000 * 60,
  });

  if (!subscription || !shouldShowSubscriptionReminder(subscription)) {
    return null;
  }

  return (
    <div className="w-full rounded-xl border border-info/20 bg-info/10 p-4 dark:border-info/30 dark:bg-info/20">
      <div className="flex items-start gap-3 min-w-0">
        <div className="size-9 shrink-0 rounded-xl bg-info/15 flex items-center justify-center">
          <Icon name="workspace_premium" aria-hidden />
        </div>
        <p className="min-w-0 flex-1 text-sm leading-snug text-foreground pt-1">
          {getSubscriptionReminderMessage(subscription)}
        </p>
      </div>
    </div>
  );
}
